import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { FaWhatsapp, FaFacebookF, FaLinkedinIn, FaYoutube } from 'react-icons/fa';
import {
  SALES_PHONE,
  SUPPORT_PHONE,
  SALES_EMAIL,
  SUPPORT_EMAIL,
  WHATSAPP_URL,
  COMPANY_ADDRESS,
  FACEBOOK_URL,
  LINKEDIN_URL,
  YOUTUBE_URL,
} from '../lib/siteContact';
import './site-footer.css';

const SiteFooter = ({ id, className = '' }) => {
  const rootClass = ['site-footer', className].filter(Boolean).join(' ');

  return (
    <footer id={id} className={rootClass}>
      <div className="site-footer__container site-footer__grid">
        <div className="site-footer__col">
          <h3>Sales Enquiry</h3>
          <a href={`tel:+91${SALES_PHONE}`}>
            <FontAwesomeIcon icon={faPhone} />
            Call / WhatsApp {SALES_PHONE}
          </a>
          <a href={`mailto:${SALES_EMAIL}`}>
            <FontAwesomeIcon icon={faEnvelope} />
            {SALES_EMAIL}
          </a>
        </div>
        <div className="site-footer__col">
          <h3>Support</h3>
          <a href={`tel:+91${SUPPORT_PHONE}`}>
            <FontAwesomeIcon icon={faPhone} />
            Call {SUPPORT_PHONE}
          </a>
          <a href={`mailto:${SUPPORT_EMAIL}`}>
            <FontAwesomeIcon icon={faEnvelope} />
            {SUPPORT_EMAIL}
          </a>
        </div>
        <div className="site-footer__col">
          <h3>Company Address</h3>
          <p>
            <FontAwesomeIcon icon={faLocationDot} />
            {COMPANY_ADDRESS}
          </p>
        </div>
        <div className="site-footer__col site-footer__social">
          <h3>Follow Us</h3>
          <div className="site-footer__icons">
            <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebookF aria-hidden />
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              className="site-footer__social-link site-footer__social-link--whatsapp"
            >
              <FaWhatsapp aria-hidden />
            </a>
            <a href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedinIn aria-hidden />
            </a>
            <a href={YOUTUBE_URL} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <FaYoutube aria-hidden />
            </a>
          </div>
        </div>
      </div>
      <div className="site-footer__copy">
        <div className="site-footer__container site-footer__copy-inner">
          <nav className="site-footer__legal" aria-label="Legal">
            <Link to="/terms-of-service">Terms of Service</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/return-refund-policy">Return &amp; Refund Policy</Link>
          </nav>
          <p className="site-footer__copyright">
            © {new Date().getFullYear()} Innovative Info Solutions. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
